import React, { Fragment } from "react";
import {
  InputLabel,
  Grid,
  FormControlLabel,
  Radio,
  TextField,
} from "material-ui";

const FrameLossLimit = ({
  translate,
  countValue,
  percentValue,
  hideCount,
  classes,
  errors,
  onChange,
  frameLossLimitToggle,
  countStart,
  countEnd,
  percentStart,
  percentEnd,
  disabled,
}) => {
  let countLabel =
    hideCount === true || disabled ? (
      translate("subset_ping_count")
    ) : (
      <b>{translate("subset_ping_count")}</b>
    );
  let percentLabel =
    hideCount !== true || disabled ? (
      translate("sub_test_percent")
    ) : (
      <b>{translate("sub_test_percent")}</b>
    );
  return (
    <Fragment>
      <div>
        <br />
        <InputLabel
          htmlFor="sub_test_frame_loss_limit"
          style={{ fontSize: "14px" }}
        >
          {translate("sub_test_frame_loss_limit")}
        </InputLabel>
        <br />
      </div>
      <Grid container>
        <Grid item xs={6}>
          <FormControlLabel
            value="true"
            control={<Radio onChange={frameLossLimitToggle} />}
            label={countLabel}
            checked={!hideCount}
            disabled={disabled}
          />
          <br />
          <TextField
            className={classes.textField}
            error={errors.countValue}
            name="countValue"
            margin="normal"
            value={countValue}
            onChange={onChange}
            disabled={hideCount || disabled}
            fullWidth
            helperText={
              errors.countValue
                ? translate("subtest_number_range", {
                    start: countStart,
                    end: countEnd,
                  })
                : ""
            }
          />
        </Grid>
        <Grid item xs={6}>
          <FormControlLabel
            value="true"
            control={<Radio onChange={frameLossLimitToggle} />}
            label={percentLabel}
            disabled={disabled}
          />
          <br />
          <TextField
            className={classes.textField}
            error={errors.percentValue}
            name="percentValue"
            margin="normal"
            value={percentValue}
            onChange={onChange}
            disabled={!hideCount || disabled}
            fullWidth
            helperText={
              errors.percentValue
                ? translate("subtest_number_range", {
                    start: percentStart,
                    end: percentEnd,
                  })
                : ""
            }
          />
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default FrameLossLimit;



// WEBPACK FOOTER //
// ./src/components/subtestsetting/common/framelosslimit.js